import { render, staticRenderFns } from "./DoctorDetailsTable.vue?vue&type=template&id=15372d98&scoped=true&"
import script from "./DoctorDetailsTable.vue?vue&type=script&lang=js&"
export * from "./DoctorDetailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15372d98",
  null
  
)

export default component.exports